/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { ScenarioVideoWithTemplatesAllOfPerformerTemplate } from './scenarioVideoWithTemplatesAllOfPerformerTemplate'
import type { ScenarioVideoWithTemplatesAllOfPerformerTemplate2 } from './scenarioVideoWithTemplatesAllOfPerformerTemplate2'
import type { ScenarioVideoWithTemplatesAllOfVideoTextTemplate } from './scenarioVideoWithTemplatesAllOfVideoTextTemplate'
import type { ScenarioVideoWithTemplatesAllOfVideoTextTemplate2 } from './scenarioVideoWithTemplatesAllOfVideoTextTemplate2'

export type ScenarioVideoWithTemplatesAllOf = {
  /** @nullable */
  videoTextTemplate2: ScenarioVideoWithTemplatesAllOfVideoTextTemplate2
  /** @nullable */
  performerTemplate2: ScenarioVideoWithTemplatesAllOfPerformerTemplate2
  /** @nullable */
  videoTextTemplate: ScenarioVideoWithTemplatesAllOfVideoTextTemplate
  /** @nullable */
  performerTemplate: ScenarioVideoWithTemplatesAllOfPerformerTemplate
}
